module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tOkgpR/tc-custom/9781614234289.jpg?1695291860520",
      "alt": "This image is the cover for the book Memphis Murder & Mayhem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Memphis Murder & Mayhem\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A journey through Memphis’ troubled past: the shocking crimes and the brutal killings that led to it being dubbed the “Murder Capital of the World.” ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With its alluring hospitality, legendary cuisine and transcendent music, Memphis is truly a quintessential Southern city. But lurking behind the barbeque and blue suede shoes is a dark history checkered with violence and disarray. Revisit the mass murder of 1866 that took more than fifty lives, the infamous Alice Mitchell case of the 1890s and a string of unthinkable twentieth-century sins. Author and lifelong Memphian Teresa Simpson explores some of the River City’s most menacing crimes and notorious characters in this riveting ride back through the centuries."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Includes photos!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Teresa R. Simpson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Teresa R. Simpson was born and raised in Memphis, Tennessee, where she lives with her husband and children. As a freelance writer, she has written numerous articles on her hometown for About.com, as well as articles and essays on a variety of subjects for other print and online publications. Teresa is also the author of The Everything Baby Sign Language Book, published by Adams Media in 2008.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0